/**
 * /historique — refonte « bonnes affaires » du 2026-09-14.
 * Les annonces consultées, avec la carte de la vitrine et le moment de la visite.
 */
import React, { useEffect, useState } from 'react';
import Page from '../components/Layout/Page';
import AffaireCard from '../components/Affaires/AffaireCard';
import BandeauAffaires from '../components/Affaires/BandeauAffaires';
import { carteDepuisAnnonce } from '../components/Affaires/format';
import api from '../services/api';
import '../components/Affaires/Affaires.css';
import './ComptePages.css';

function ilYa(date) {
  const minutes = Math.floor((Date.now() - new Date(date).getTime()) / 60000);
  if (minutes < 1) return "à l'instant";
  if (minutes < 60) return `il y a ${minutes} min`;
  const heures = Math.floor(minutes / 60);
  if (heures < 24) return `il y a ${heures} h`;
  const jours = Math.floor(heures / 24);
  return `il y a ${jours} jour${jours > 1 ? 's' : ''}`;
}

export default function HistoryPage() {
  const [historique, setHistorique] = useState([]);
  const [chargement, setChargement] = useState(true);

  useEffect(() => {
    api.get('/api/history/')
      .then((r) => setHistorique(r.data || []))
      .catch(() => {})
      .finally(() => setChargement(false));
  }, []);

  const n = historique.length;

  return (
    <Page
      titre="Annonces consultées"
      chapeau={chargement ? 'Chargement…' : `${n} annonce${n > 1 ? 's' : ''} consultée${n > 1 ? 's' : ''} récemment.`}
    >
      {!chargement && n === 0 && (
        <div className="zk-carte zk-cpt-vide">
          <h2>Aucune annonce consultée</h2>
          <p>Les annonces que vous ouvrez apparaîtront ici.</p>
        </div>
      )}

      {n > 0 && (
        <div className="zk-cpt-grille">
          {historique.map((item, i) => (
            <div key={`${item.listing.id}-${i}`} className="zk-cpt-item">
              <AffaireCard a={carteDepuisAnnonce(item.listing)} />
              <div className="zk-cpt-action"><span>Consultée {ilYa(item.viewed_at)}</span></div>
            </div>
          ))}
        </div>
      )}

      {!chargement && <BandeauAffaires />}
    </Page>
  );
}
